import { ArrowRightIcon } from '@/assets/icons'
import React from 'react'
import CountChip from './CountChip'
import { HeaderRow, IconChip, Label, TileArrow } from './TileHeader.styles'
import { iconSizes } from '@/theme/tokens'

interface TileHeaderProps {
	/** Pre-sized section icon; rendered inside the warm-tint chip (inherits orange-dark). */
	icon: React.ReactNode
	label: string
	/** Optional count chip content (e.g. "16 days", "6"). Omit to hide the chip. */
	count?: React.ReactNode
	/** Whether to render the hover arrow (hidden until the tile is hovered). */
	showArrow?: boolean
}

/** The header row shared by every bento tile: icon chip + label + count + hover arrow. */
const TileHeader: React.FC<TileHeaderProps> = ({ icon, label, count, showArrow = true }) => (
	<HeaderRow>
		<IconChip>{icon}</IconChip>
		<Label>{label}</Label>
		{count != null && <CountChip>{count}</CountChip>}
		{showArrow && (
			<TileArrow aria-hidden="true">
				<ArrowRightIcon sx={{ fontSize: iconSizes.sm }} />
			</TileArrow>
		)}
	</HeaderRow>
)

export default TileHeader
